/**
 * Handles the dealer form.
 * Validation and switching between the steps.
 */

define('libs/dealerform',['libs/validation',
    'libs/dealerform.zipcodeform'], function(ValidationForm, ZipcodeForm) {

    'use strict';

    //var ValidationForm = require('libs/validation')

    var SETTINGS = {
        stepSelector: '.dealer-appointment',
        stepLinkSelector: '[data-goto-step]',
        zipcodeFormSelector: '.form-postcode',
        addProductSelector: '.btn-add',
        classActive: 'active',
        classDisabled: 'disabled'
    };

    var DealerForm = function(form, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.form = $(form);

        // add validation to the form.
        this.validator = new ValidationForm(form, {
            validationSelector: '.validate'
        });

        // initialize the step-navigation buttons.
        this.form.on('click', this.settings.stepLinkSelector, this.onNavClick.bind(this));

        // handle the form submit.
        this.form.on('submit', this.onSubmit.bind(this));

        // get the steps.
        this.steps = this.form.find(this.settings.stepSelector);
        // get the active step.
        this.activeStepContainer = this.steps.filter('.' + this.settings.classActive);

        // initialize the validation per step.
        this.steps.each(function(i, step) {
            var _step = $(step);
            // set step disabled.
            if (i > 0) {
                _step.addClass(this.settings.classDisabled);
            }

            _step.on('validate.validation', function(event) {
                var valid = this.validateStep(_step);
                this.setStepState(this.steps.eq(this.steps.index(event.currentTarget) + 1),
                    valid ? 'valid' : 'invalid');
            }.bind(this));
        }.bind(this));

        // initialize the zipcode form.
        var zipcodeFormElement = $(this.settings.zipcodeFormSelector);
        if (zipcodeFormElement.length) {
            var zipcodeForm = new ZipcodeForm(zipcodeFormElement[0], {
                classValid: this.validator.settings.classValid
            });

            // listen for the dealer retrieved and inserted into step 2.
            zipcodeFormElement.on(zipcodeForm.EVENT.dealerlistBuild, function() {
                // go to the next step.
                this.gotoStep(this.steps.eq(1));

                // update the validations with the new elements from the dealer list.
                this.validator.updateForm();
            }.bind(this));
        }

        // initialize the add-product button.
        var btnAdd = this.form.find(this.settings.addProductSelector),
            productSelector = btnAdd.data('add');

        // cache the product node in it's original state.
        this.getCachedProductNode(productSelector);

        btnAdd.on('click', this.addProduct.bind(this));
    };

    /**
     *
     */
    DealerForm.prototype.gotoStep = function(element) {
        this.activeStepContainer.removeClass(this.settings.classActive);
        element.addClass(this.settings.classActive);
        this.activeStepContainer = element;
    };

    DealerForm.prototype.onNavClick = function(event) {
        event.preventDefault();
        var step = event.currentTarget.getAttribute('data-goto-step'),
            stepContainer;

        if (step) {
            stepContainer = this.form.find('.step-' + step);
            if (stepContainer.length) {
                // if it's a previous step or the step may be skipped, just go to the step.
                if (step < this.steps.index(this.activeStepContainer) + 1 || $(event.currentTarget).hasClass('btn-over')) {
                    this.gotoStep(stepContainer);
                } else {
                    // validate the current step.
                    var valid = this.validateStep(this.activeStepContainer);
                    // if all fields validate, go to the step.
                    if (valid) {
                        this.gotoStep(stepContainer);
                    }
                }
            }
        }
    };

    DealerForm.prototype.setStepState = function(element, state) {
        if (state == 'invalid') {
            element.addClass(this.settings.classDisabled);
        } else {
            element.removeClass(this.settings.classDisabled);
            // TODO CSS -> Show next button
        }
    };

    DealerForm.prototype.validateStep = function(element) {
        var valid = true,
            formElements = element.find(this.validator.settings.validationSelector);

        formElements.each(function(i, element) {
            if (!$(element).hasClass(this.validator.settings.classValid)) {
                valid = false;
            }
        }.bind(this));

        element[valid ? 'addClass' : 'removeClass']('valid');

        return valid;
    };

    DealerForm.prototype.onSubmit = function(event) {
        if (!this.form.hasClass(this.validator.settings.classInvalid)) {
            var url = this.form[0].getAttribute('action');
            if (url == '#') { // IE9 doesn't submit with only a #.
                url = window.location.href;
            }
            if (url) {
                event.preventDefault();
                $.ajax(url, {
                    success: this.handleFormResponse.bind(this),
                    error: this.onError.bind(this)
                });
            }
        }
    };

    /**
     * After the form is submitted, go to the last step.
     */
    DealerForm.prototype.handleFormResponse = function() {
        // this.gotoStep(this.steps.last());
        var thismain = this;
        var formData = this.form.serialize();
        $.ajax({
            url: fs_obj.ajaxurl,
            type: 'POST',
            data: {
                action: 'process_appointment',
                form_data: formData
            },
            success: function(html){
                $('.thank-you').html(html);
                thismain.gotoStep(thismain.steps.last());
            }
        });
    };

    DealerForm.prototype.onError = function() {
        // DO SOMETHING ON ERROR?
    };

    DealerForm.prototype.addProduct = function(event) {
        event.preventDefault();
        var productContainer = $($(event.currentTarget).data('add')).last();

        if (productContainer.length && this.productNode.length) {
            var copy = productContainer.clone(),
                btnRemove = $('<span class="btn-remove">'+fs_obj.delete_product_str+'</span>');

            copy.find('select, input').each(function () {
                var num = parseInt(this.name.match(/\d/g),10);
                this.name = this.name.replace(/\d/g, num + 1);
                this.className = this.className.replace('invalid', '');
            });

            btnRemove.on('click', function(self) {
                // remove the product.
                this.remove();
                // remove the button.
                self.remove();
            }.bind(copy, btnRemove));

            copy.insertAfter(productContainer);
            btnRemove.insertBefore(copy);
            // update the validations with the new elements.
            this.validator.updateForm();
        }
    };

    DealerForm.prototype.getCachedProductNode = function(selector) {
        this.productNode = this.productNode || $(selector).clone();
        return this.productNode;
    };

    return DealerForm;
});

